/**
 * @flow
 * @relayHash c3f0019cc4df7e263a88debac2984a54
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AppContainer_viewer$ref = any;
export type Route_App_QueryVariables = {||};
export type Route_App_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: AppContainer_viewer$ref
  |}
|};
export type Route_App_Query = {|
  variables: Route_App_QueryVariables,
  response: Route_App_QueryResponse,
|};
*/


/*
query Route_App_Query {
  viewer {
    ...AppContainer_viewer
    id
  }
}

fragment AppContainer_viewer on User {
  id
  first_name
  last_name
  s_time_zone
  ...AvailabilityCheckerContainer_viewer
}

fragment AvailabilityCheckerContainer_viewer on User {
  ...AvailabilityCalendarContainer_viewer
  s_time_zone
  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 99999,
  "type": "Int"
},
v2 = {
  "kind": "Literal",
  "name": "return_empty_connection",
  "value": true,
  "type": "Boolean"
},
v3 = {
  "kind": "Literal",
  "name": "visibility",
  "value": [
    "SHOW"
  ],
  "type": "[UserEventVisibility]"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start_at",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end_at",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "UserEventEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEvent",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [
              v0,
              v4
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "booking_status",
            "args": null,
            "storageKey": null
          },
          v5,
          v6,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event_segments",
            "storageKey": "user_event_segments(first:99999)",
            "args": [
              v1
            ],
            "concreteType": "UserEventSegmentConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegmentEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [
                      v4,
                      v5,
                      v6,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "all_day",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "location",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "room",
                        "args": null,
                        "storageKey": null
                      },
                      v0
                    ]
                  }
                ]
              }
            ]
          },
          v0
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "Route_App_Query",
  "id": null,
  "text": "query Route_App_Query {\n  viewer {\n    ...AppContainer_viewer\n    id\n  }\n}\n\nfragment AppContainer_viewer on User {\n  id\n  first_name\n  last_name\n  s_time_zone\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment AvailabilityCheckerContainer_viewer on User {\n  ...AvailabilityCalendarContainer_viewer\n  s_time_zone\n  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Route_App_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "AppContainer_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "Route_App_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          v0,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "first_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "last_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_time_zone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": "AvailabilityCalendarContainer_user_events",
            "name": "user_events",
            "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
            "args": [
              {
                "kind": "Literal",
                "name": "booking_status",
                "value": [
                  "BOOKED",
                  "INITIAL",
                  "CANCELED"
                ],
                "type": "[BookingStatus]"
              },
              v1,
              v2,
              v3
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": v7
          },
          {
            "kind": "LinkedField",
            "alias": "AvailabilityCheckerContainer_user_events",
            "name": "user_events",
            "storageKey": "user_events(first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
            "args": [
              v1,
              v2,
              v3
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": v7
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0adaf99a9e0815b2ce2262b317f5739a';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/routes/__generated__/Route_App_Query.graphql.js